import { observer, useObserver } from "mobx-react";
import * as React from "react";
import Localization from "../../core/Localization";
import Routing from "../../core/Routing";
import Sys from "../../core/Sys";
import MenuItem from "../../coreui/MenuItem";
import { ActionButtonProps, ActionButtonRuntimeProps } from "../ActionButton";
import Api from "../Api";
import ApiButton from "../ApiButton";
import { MenuItemProps } from "../MenuItem";

interface Props extends ActionButtonProps {}

@observer
export class SignInButton extends React.Component<Props> {
  private static signInError(): void {
    Routing.goToErrorPage(
      "Use configured authentication must be enabled for sign in " +
        "functionality"
    );
  }

  public static renderMenuItem(props: MenuItemProps): JSX.Element {
    const { config, runtime, ...otherProps } = props;
    const configProps = (config as unknown) as Props;
    const runtimeProps = runtime as ActionButtonRuntimeProps;
    let url: string | undefined;
    if (Sys.settings.useConfiguredAuthentication) {
      url = "#/signin";
    }

    return useObserver(() => (
      <MenuItem
        href={url}
        iconName={configProps.iconName}
        indent={props.config.propagated ? props.config.propagated.indent : 0}
        onClick={url ? undefined : SignInButton.signInError}
        {...otherProps}
      >
        {runtimeProps.label}
      </MenuItem>
    ));
  }

  public render(): React.ReactNode {
    const runtimeProperties = Api.getWidgetProperties(
      this.props
    ) as ActionButtonRuntimeProps;
    let url: string | undefined;
    if (Sys.settings.useConfiguredAuthentication) {
      url = "#/signin";
    }

    const isIconOnly = !runtimeProperties.label;
    const label = isIconOnly
      ? Localization.getBuiltInMessage("signIn")
      : runtimeProperties.label;

    return (
      <ApiButton
        alternateText={runtimeProperties.alternateText}
        buttonColor={this.props.buttonColor}
        dataId={this.props.dataId}
        disabled={false}
        disabledHelpText={this.props.disabledHelpText}
        href={url}
        iconName={this.props.iconName}
        isIconOnly={isIconOnly}
        label={label}
        name={this.props.name}
        onClick={url ? undefined : SignInButton.signInError}
        renderAsLink={this.props.renderAsLink}
        size={this.props.size}
      />
    );
  }
}

export default SignInButton;
